type ResolveWorkspaceLaunchToolIdInput = {
  boundToolId: string | null | undefined;
  defaultToolId: string | null | undefined;
  isWorkspacePage: boolean;
};

export function resolveWorkspaceLaunchToolId({
  boundToolId,
  defaultToolId,
  isWorkspacePage,
}: ResolveWorkspaceLaunchToolIdInput) {
  return boundToolId ?? (isWorkspacePage ? defaultToolId : null) ?? null;
}
